import React from "react";
import { useIntl } from "@leagueplatform/locales";
import { usePageViewAnalytics } from "@leagueplatform/analytics";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { Masonry } from "@leagueplatform/masonry";
import { MASONRY } from "common/constants";
import { PageContentWrapper } from "components/page-content-wrapper.component";
import { PageHeader } from "components/page-header/page-header.component";

export const HowToShareResultsPage = () => {
  usePageViewAnalytics({ screen_name: "How To Share Results" });
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: "STR_LEARN_HOW_TO_SHARE_RESULTS" }));

  return (
    <PageContentWrapper>
      <PageHeader
        headingText={formatMessage({ id: "STR_LEARN_HOW_TO_SHARE_RESULTS" })}
        showBackButton
      />
      <Masonry rootNodeId={MASONRY.ROOT_NODE_ID_LEARN_HOW_TO_SHARE_RESULTS} />
    </PageContentWrapper>
  );
};
